module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-2.200a7baa.jpg";